export default __webpack_public_path__ + "static/media/decoding-love.c0a26a92.jpg";